import loadable from '@loadable/component';
import { WithConditionalHydration } from '../../../WithConditionalHydration';
import { domainService } from '../../../../domain/services/domainService';

const DrupalEditLoadable = loadable(() => import('./DrupalEdit'), {
  resolveComponent: components => components.DrupalEdit,
  ssr: false
});

export const DrupalEdit = WithConditionalHydration(
  DrupalEditLoadable,
  domainService.isRunningOnCMS
);
